import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "folder__wrapper"
}
const _hoisted_2 = { class: "folder-page" }
const _hoisted_3 = { class: "folder-page__header" }
const _hoisted_4 = { class: "folder-page__header-left" }
const _hoisted_5 = { class: "folder-page__link" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "/", -1)
const _hoisted_7 = { class: "folder-page__link-title" }
const _hoisted_8 = { class: "folder-page__header-delete" }
const _hoisted_9 = { class: "folder-page__content" }
const _hoisted_10 = {
  key: 0,
  class: "folder-list"
}
const _hoisted_11 = { class: "folder__show-menu folder-list__item" }
const _hoisted_12 = { class: "folder__show-btns" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "folder-list__item folder-list__noshow" }
const _hoisted_16 = { class: "list__title folder-list__title" }
const _hoisted_17 = { class: "list__item folder folder-list__text" }
const _hoisted_18 = { class: "list__english" }
const _hoisted_19 = { class: "list__russian" }
const _hoisted_20 = {
  key: 1,
  class: "folder-page-notfound"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, { to: "/folders" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.t("header.sections")), 1)
                  ]),
                  _: 1
                }),
                _hoisted_6,
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.folderItem.title), 1)
              ]),
              _createVNode(_component_router_link, {
                to: '/folders/' + _ctx.$route.params.id + '/delete?title=' + _ctx.folderItem.title
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.t("account.wordsTable.panel.delete")), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.folderItem?.listModules != null && _ctx.folderItem?.listModules.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folderItem.listModules, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "folder-list__item-wrapper",
                        onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.redirectWords(item.title))
                            }, _toDisplayString(_ctx.t("folders.learn")), 9, _hoisted_13),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.deleteList(item.title))
                            }, _toDisplayString(_ctx.t("folders.removeFromList")), 9, _hoisted_14)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("h3", null, _toDisplayString(item.title), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.words, (words, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "list__words folder-list__item"
                            }, [
                              _createElementVNode("p", _hoisted_17, [
                                _createElementVNode("span", _hoisted_18, _toDisplayString(words.english), 1),
                                _createTextVNode(" - "),
                                _createElementVNode("span", _hoisted_19, _toDisplayString(words.russian), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ], 32))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.t("folders.noAdded")), 1)
                  ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoader)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      : (_openBlock(), _createBlock(_component_Loader, { key: 2 }))
  ], 64))
}